<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      <app-form-delete-button [Parent]="this" [Model]="Model" DeleteUrl="valet/inventory/" Api="valet" NameProperty="TicketNumber"
      TypeName="ValetParkingSession" DeleteNavLink="/valet/inventory"></app-form-delete-button>
    </app-pageheader>
    <app-tabs>
      <app-tab Title="Details">
        <div class="columns equal-height-columns">
          <div class="column is-6">
            <article class="panel">
              <p class="panel-heading">
                Session Details
              </p>
              <div class="panel-block">
                <span class="label">Id:</span>
                <span class="value">{{Model.Id}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Ticket Number:</span>
                <span class="value">{{Model.TicketNumber}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Key Tag:</span>
                <span class="value">{{Model.KeyTagIdentifier}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Key State:</span>
                <span class="value">{{Model.KeyStateString}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Valet Station:</span>
                <span class="value">{{Model.ValetStationName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Valet Type:</span>
                <span class="value">{{Model.ValetTypeName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Rate Set:</span>
                <span class="value">{{Model.ParkingRateSetName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Start Date:</span>
                <span class="value">{{Model.StartDateLocalString}}</span>
              </div>
              <div class="panel-block">
                <span class="label">End Date:</span>
                <span class="value">{{Model.EndDateLocalString}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Expecting Survey Response:</span>
                <span class="value">{{Model.ExpectingSurveyResponse ? 'Yes' : 'No'}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Parking Lot:</span>
                <span class="value">{{Model.ParkingLotName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Parking Space:</span>
                <span class="value">{{Model.ParkingSpaceNumber}}</span>
              </div>
            </article>
          </div>
          <div class="column is-6 stacked-panels">
            <article class="panel">
              <p class="panel-heading">
                Customer Details
              </p>
              <div class="panel-block">
                <span class="label">First Name:</span>
                <span class="value">{{Model.CustomerFirstName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Last Name:</span>
                <span class="value">{{Model.CustomerLastName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Phone:</span>
                <span class="value">{{Model.CustomerPhoneNumber}}</span>
              </div>
            </article>
            <article class="panel">
              <p class="panel-heading">
                Vehicle Details
              </p>
              <div class="panel-block">
                <span class="label">Registration Number:</span>
                <span class="value">{{Model.PlateNumber}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Brand:</span>
                <span class="value">{{Model.VehicleBrandName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Model:</span>
                <span class="value">{{Model.VehicleModelName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Color:</span>
                <span class="value">{{Model.VehicleColorName}}</span>
              </div>
            </article>
          </div>
        </div>
        <div class="columns equal-height-columns">
          <div class="column is-6">
            <article class="panel">
              <p class="panel-heading">
                Workflow State
              </p>
              <div class="panel-block">
                <span class="label">Current State:</span>
                <span class="value">{{Model.CurrentStateName}}</span>
              </div>
              <div class="panel-block">
                <span class="label">State Entered:</span>
                <span class="value">{{Model.StateEnteredDateLocalFriendlyString}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Active:</span>
                <span class="value">{{Model.IsActiveState ? 'Yes' : 'No'}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Final:</span>
                <span class="value">{{Model.IsFinalState ? 'Yes' : 'No'}}</span>
              </div>
            </article>
          </div>
          <div class="column is-6">
            <article class="panel">
              <p class="panel-heading">
                Payment Summary
              </p>
              <div class="panel-block">
                <span class="label">Total Required:</span>
                <span class="value">{{orgService.GetCurrencySymbol()}}{{Model.TotalPaymentRequired?.toFixed(2)}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Total Paid:</span>
                <span class="value">{{orgService.GetCurrencySymbol()}}{{Model.TotalPaid?.toFixed(2)}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Outstanding:</span>
                <span class="value" [ngStyle]="{'color': Model.TotalOutstanding > 0 ? 'red' : 'inherit'}">
                  {{orgService.GetCurrencySymbol()}}{{Model.TotalOutstanding?.toFixed(2)}}
                </span>
              </div>
            </article>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <article class="panel">
              <p class="panel-heading">
                Payments
              </p>
              @if (Model.Payments?.length > 0) {
                <table class="table is-fullwidth is-striped">
                  <thead>
                    <tr>
                      <th>Amount</th>
                      <th>Type</th>
                      <th>Txn Reference</th>
                      <th>Paid From</th>
                      <th>Paid To</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (payment of Model.Payments; track payment) {
                      <tr>
                        <td>{{orgService.GetCurrencySymbol()}}{{payment.Amount?.toFixed(2)}}</td>
                        <td>{{payment.PaymentType}}</td>
                        <td>{{payment.TransactionReference}}</td>
                        <td>{{payment.PaidFromLocalString}}</td>
                        <td>{{payment.PaidToLocalString}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
              @if (!Model.Payments?.length) {
                <div class="panel-block" style="color: #999;">
                  No Payments
                </div>
              }
            </article>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <article class="panel">
              <p class="panel-heading">
                Parking History
              </p>
              @if (Model.Durations?.length > 0) {
                <table class="table is-fullwidth is-striped">
                  <thead>
                    <tr>
                      <th>Start</th>
                      <th>End</th>
                      <th>Parking Lot</th>
                      <th>Space</th>
                      <th>Rate Set</th>
                      <th>Entry Plate</th>
                      <th>Exit Plate</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (duration of Model.Durations; track duration) {
                      <tr>
                        <td>{{duration.StartDateLocalString}}</td>
                        <td>{{duration.EndDateLocalString || 'In progress'}}</td>
                        <td>{{duration.ParkingLotName}}</td>
                        <td>{{duration.ParkingSpaceNumber}}</td>
                        <td>{{duration.ParkingRateSetName}}</td>
                        <td>{{duration.EntryLanePlateNumber}}</td>
                        <td>{{duration.ExitLanePlateNumber}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
              @if (!Model.Durations?.length) {
                <div class="panel-block" style="color: #999;">
                  No parking history
                </div>
              }
            </article>
          </div>
        </div>
        @if (Model.Survey) {
          <div class="columns">
            <div class="column is-12">
              <article class="panel">
                <p class="panel-heading">
                  Customer Survey
                </p>
                @if (Model.Survey.ReceivedAt) {
                  <div class="panel-block">
                    <span class="label">Received At:</span>
                    <span class="value">{{Model.Survey.ReceivedAt | date:'medium'}}</span>
                  </div>
                }
                @if (Model.Survey.Rating != null) {
                  <div class="panel-block">
                    <span class="label">Rating:</span>
                    <span class="value" style="white-space:nowrap; color:#f5a623;">
                      @for (i of [1,2,3,4,5]; track i) {
                        <i [class]="i <= Model.Survey.Rating ? 'fa fa-star' : 'fa fa-star-o'"
                        style="margin-right:2px;"></i>
                      }
                    </span>
                  </div>
                }
                @if (Model.Survey.Survey) {
                  <div class="panel-block">
                    <span class="label">Response:</span>
                    <span class="value">
                      <pre style="white-space: pre-wrap; word-wrap: break-word; margin: 0;">{{Model.Survey.Survey}}</pre>
                    </span>
                  </div>
                }
                <div class="panel-block">
                  <a [routerLink]="['/valet/surveys', Model.Survey.Id]">View survey details</a>
                </div>
              </article>
            </div>
          </div>
        }
      </app-tab>
      <app-tab Title="Images">
        <div class="columns">
          <div class="column is-12">
            <article class="panel">
              <p class="panel-heading">
                Images
              </p>
              @if (Model.Images?.length > 0) {
                <div class="panel-block">
                  @for (image of Model.Images; track image) {
                    <div style="display: inline-block; text-align: center; margin: 4px;">
                      <button type="button"
                        style="border: 0; background: transparent; padding: 0; cursor: pointer;"
                        [attr.aria-label]="'Open ' + (image.Category || 'Valet Image')"
                        (click)="openDamageCheckImage(image, image.Category || 'Valet Image')">
                        <app-mediaviewer [MediaId]="image.MediaId" Width="120px" Height="120px" [Thumbnail]="true">
                        </app-mediaviewer>
                      </button>
                      <div style="font-size: 0.75rem; color: #666;">
                        {{image.CapturedAtLocalFriendlyString || (image.CapturedAt | date:'short')}}
                      </div>
                      @if (image.Category) {
                        <div style="font-size: 0.75rem; color: #999;">
                          {{image.Category}}
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (!Model.Images?.length) {
                <div class="panel-block" style="color: #999;">
                  No Images
                </div>
              }
            </article>

            <article class="panel" style="margin-top: 0.75rem;">
              <p class="panel-heading">
                General Damage Check
              </p>
              @if (Model.GeneralDamageCheckImages?.length > 0) {
                <div class="panel-block">
                  @for (image of Model.GeneralDamageCheckImages; track image) {
                    <div style="display: inline-block; text-align: center; margin: 4px;">
                      <button type="button"
                        style="position: relative; display: inline-block; line-height: 0; cursor: pointer; border: 0; background: transparent; padding: 0;"
                        aria-label="Open General Damage Check image"
                        (click)="openDamageCheckImage(image, 'General Damage Check')">
                        <app-mediaviewer [MediaId]="image.MediaId" Width="120px" Height="120px" [Thumbnail]="true">
                        </app-mediaviewer>
                        @for (c of image.DamageCheckCoordinates; track c) {
                          <div
                            [ngStyle]="{
                              'position': 'absolute',
                              'left.%': c.X * 100,
                              'top.%': c.Y * 100,
                              'width.px': 6,
                              'height.px': 6,
                              'border-radius': '50%',
                              'border': '1px solid #fff',
                              'box-shadow': '0 0 0 1px rgba(0, 0, 0, 0.4)',
                              'transform': 'translate(-50%, -50%)',
                              'pointer-events': 'none',
                              'background-color': damageDotColor(c.Type)
                            }">
                          </div>
                        }
                      </button>
                      <div style="font-size: 0.75rem; color: #666;">
                        {{image.CapturedAtLocalFriendlyString || (image.CapturedAt | date:'short')}}
                      </div>
                      @if (image.DamageCheckCoordinates?.length) {
                        <div style="font-size: 0.75rem; color: #999;">
                          {{image.DamageCheckCoordinates.length}} marker(s)
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (!Model.GeneralDamageCheckImages?.length) {
                <div class="panel-block" style="color: #999;">
                  No General Damage Check Images
                </div>
              }
            </article>
          </div>
        </div>
      </app-tab>
      <app-tab Title="Send Message">
        <div class="columns is-centered">
          <div class="column is-5">
            <div class="message-panel">
              <div class="field">
                <label class="label">To</label>
                <input class="input" type="text" [value]="Model.CustomerPhoneNumber || 'No phone number'" readonly>
              </div>
              <div class="field">
                <label class="label">Message</label>
                <textarea [(ngModel)]="NewMessageContent" placeholder="Type a message..." rows="3"
                class="textarea" (keydown.enter)="sendMessage($event)"></textarea>
              </div>
              <div class="message-compose-actions">
                <button class="button is-primary is-small" [disabled]="!NewMessageContent?.trim() || !Model.CustomerPhoneNumber || SendingMessage"
                  (click)="sendMessage()">
                  <span class="icon is-small"><i class="fa fa-paper-plane"></i></span>
                  @if (!SendingMessage) {
                    <span>Send</span>
                  }
                  @if (SendingMessage) {
                    <span>Sending...</span>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      </app-tab>
      <app-tab Title="Timeline">
        <div class="columns">
          <div class="column is-12">
            <article class="panel">
              <p class="panel-heading">
                Timeline
              </p>
              <div class="panel-block" style="display: block; padding: 1rem 1.25rem;">
                @if (Model.CustodyEvents?.length > 0) {
                  <div class="custody-timeline">
                    @for (event of Model.CustodyEvents; track event) {
                      <div class="timeline-item">
                        <span class="timeline-time">{{event.OccuredAtLocalFriendlyString || (event.OccuredAt | date:'short')}}</span>
                        <div class="timeline-marker"></div>
                        <div class="timeline-pills">
                          <span class="pill pill-user"><i class="fa" [ngClass]="{'fa-user': event.EventType !== 'Sent SMS' && event.EventType !== 'Received SMS', 'fa-comment': event.EventType === 'Sent SMS' || event.EventType === 'Received SMS'}"></i> {{event.PerformedByName || 'Guest'}}</span>
                          <span class="pill-arrow">→</span>
                          <span class="pill pill-action">{{event.Description || event.EventType}}</span>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (!Model.CustodyEvents?.length) {
                  <div style="color: #999;">
                    No custody events recorded.
                  </div>
                }
              </div>
            </article>
          </div>
        </div>
      </app-tab>
    </app-tabs>
  </div>
}
